import React from 'react';
import { useSelector } from 'react-redux';
import {
  ensureContrast,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_SURFACE,
} from '~/modules/Helper/contrast.helper';
import * as S from './SectionTitle.styled';

function SectionTitle({ titulo, icon }) {
  const corTema = useSelector(state => state.configuration.corTema);
  const corSegura = ensureContrast(
    corTema,
    AA_SURFACE,
    4.5,
    AA_TEXT_PRIMARY_ON_LIGHT
  );

  return (
    <S.Heading color={corSegura}>
      {icon}
      {titulo}
    </S.Heading>
  );
}

export default SectionTitle;
